var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('labeled-content',{class:{compact: _vm.compact},attrs:{"label":"Issued by","label-offset":_vm.compact ? '2px' : undefined}},[_c('person-name-text',{staticClass:"field-value",attrs:{"of":_vm.issuedBy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }